import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { formatDotsRut } from '@imedcl/valida-rut';

import AppContext from '../../Context/AppContext';
import QFlogo from '../../../images/QF-logo.svg';
import Farmalogo from '../../../images/Farmacia-logo.svg';

function Perfil() {
  const { state, dispatch } = useContext(AppContext);
  const history = useHistory();

  const Logout = (e) => {
    e.preventDefault();
    dispatch({
      type: 'SET_LOGIN',
      value: false,
    });
    window.localStorage.clear();
    history.push('/');
  };
  useEffect(() => {
  }, [state]);

  return (
    <Dropdown className="navbarPerfil">
      <Dropdown.Toggle>
        <div className="ml-auto">
          <div className="d-flex justify-content-end align-items-center">
            <div className="row">
              <div className="col-12 navbarPerfil">
                <i className="fas fa-bars" />
              </div>
            </div>
          </div>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div className="navbarPerfil__content">
          <div className="row justify-content-center">
            <div className="InfoLogin">
              <p className="mt-2">
                <img src={QFlogo} className="float-left" alt="QF logo" />
                <span className="NameQF">Químico Farmacéutico</span>
                <br />
                <span>
                  Rut:
                  {' '}
                  {formatDotsRut(state.dataLogin.rut)}
                </span>
              </p>
              <p className="mb-0">
                <img src={Farmalogo} className="float-left" alt="Farmacia Logo" />
                <span className="CodePharma">Código del Local</span>
                <br />
                <span>
                  <b>{state.dataLogin.code}</b>
                </span>
              </p>
            </div>
          </div>
          <div className="dropdown-divider" />
          <Dropdown.Item className="btn btnLogout mt-2" onClick={(e) => Logout(e)}>Cerrar Sesión</Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
export default Perfil;
